import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MethodConfig } from '@/models/config';


interface DialogTitleProps {
  open: boolean;
  onClose: () => void;
  iframe: string;
  title: string;
  type?: number;
}

export default function IframeDialog({
  open,
  onClose,
  iframe,
  title,
  type
}: DialogTitleProps) {
  const variantsCssType = React.useMemo((): { [key: string]: string | number } => {
    switch (type) {
      case MethodConfig.YOUTUBE:
        return {
          p: 0,
          height: '100%',
          overflow: 'hidden',
          position: "relative",
          boxSizing: "content-box",
          maxHeight: "50vh",
          width: "100%",
          maxWidth: "50vw",
          aspectRatio: "1.8132716049382716",
          padding: "30px"
        };
      case MethodConfig.SUPADEMO:
        return {
          p: 0,
          height: '100%',
          overflow: 'hidden',
          position: "relative",
          boxSizing: "content-box",
          maxHeight: "80vh",
          width: "100%",
          maxWidth: "71vw",
          aspectRatio: "1.8132716049382716",
          padding: "40px 0 40px 0"
        };
      default:
        return {};
    }
  }, [type])
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      slotProps={{
        paper: {
          sx: variantsCssType
        }
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
          color: (theme) => theme.palette.grey[500],
          zIndex: 1,
          '&:hover': {
            color: (theme) => theme.palette.grey[700],
          }
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className="!p-0 relative overflow-hidden" >
        <iframe
          src={iframe}
          loading="lazy"
          title={title}
          allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay"
          frameBorder="0"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            borderRadius: "8px",
            width: "100%",
            height: "100%"
          }}
        ></iframe>
      </DialogContent>
    </Dialog>
  );
}
